var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.001,
    height: 17.418,
    viewBox: "0 0 19.001 17.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5986",
    "data-name": "Group 5986",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12732",
    "data-name": "Path 12732",
    className: "cls-1",
    d: "M16.626,1H2.375A2.378,2.378,0,0,0,0,3.375V16.042a2.378,2.378,0,0,0,2.375,2.375H16.626A2.378,2.378,0,0,0,19,16.042V3.375A2.378,2.378,0,0,0,16.626,1Zm0,15.834H2.375a.793.793,0,0,1-.792-.792V4.959H17.418V16.042A.793.793,0,0,1,16.626,16.834Z",
    transform: "translate(0 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5987",
    "data-name": "Group 5987",
    transform: "translate(8.709 7.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12733",
    "data-name": "Path 12733",
    className: "cls-1",
    d: "M17.334,10.583H11.792a.792.792,0,1,1,0-1.583h5.542a.792.792,0,0,1,0,1.583Z",
    transform: "translate(-11 -9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5988",
    "data-name": "Group 5988",
    transform: "translate(8.709 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12734",
    "data-name": "Path 12734",
    className: "cls-1",
    d: "M17.334,14.583H11.792a.792.792,0,1,1,0-1.583h5.542a.792.792,0,0,1,0,1.583Z",
    transform: "translate(-11 -13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(8.709 13.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12735",
    "data-name": "Path 12735",
    className: "cls-1",
    d: "M17.334,18.583H11.792a.792.792,0,0,1,0-1.583h5.542a.792.792,0,0,1,0,1.583Z",
    transform: "translate(-11 -17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5990",
    "data-name": "Group 5990",
    transform: "translate(3.167 7.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12736",
    "data-name": "Path 12736",
    className: "cls-1",
    d: "M7.167,10.583H4.792A.792.792,0,1,1,4.792,9H7.167a.792.792,0,1,1,0,1.583Z",
    transform: "translate(-4 -9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5991",
    "data-name": "Group 5991",
    transform: "translate(3.167 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12737",
    "data-name": "Path 12737",
    className: "cls-1",
    d: "M7.167,14.583H4.792a.792.792,0,1,1,0-1.583H7.167a.792.792,0,1,1,0,1.583Z",
    transform: "translate(-4 -13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5992",
    "data-name": "Group 5992",
    transform: "translate(3.167 13.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12738",
    "data-name": "Path 12738",
    className: "cls-1",
    d: "M7.167,18.583H4.792a.792.792,0,0,1,0-1.583H7.167a.792.792,0,1,1,0,1.583Z",
    transform: "translate(-4 -17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDashboard);
export default __webpack_public_path__ + "static/media/SurveyDashboard.4a1480245b84336bc0cb56b308204555.svg";
export { ForwardRef as ReactComponent };